import React, { useRef, useState } from 'react';

const useSearchInput = () => {
  const [searchInput, setSearchInput] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState('');
  const wrapperRef = useRef(null);
  const handleSearchInputValue = (event: any) => {
    setSearchInputValue(event.target.value);
  };

  return {
    searchInputValue,
    setSearchInputValue,
    handleSearchInputValue,
    searchInput,
    setSearchInput,
    wrapperRef,
  };
};

export default useSearchInput;
